// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__3N_Gk","active":"styles_active__m8BWg","btn":"styles_btn__2jbg6"};